import React, { useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

import { useWarehouseContext } from 'providers/WarehouseProvider';
import useExcelUpload from 'hooks/useExcelUpload';

import Table from 'components/common/Table';

import { bulkActionApi } from 'api';

import {
  BULK_ACTION_SELECT,
  BULK_ACTION_LIST_COLUMNS,
} from 'constants/bulkAction';

const BulkAction = () => {
  const tableRef = useRef();
  const [searchParams] = useSearchParams();
  const currentBulkActionType =
    searchParams.get(BULK_ACTION_SELECT.field) || '';

  const { selectedWarehouse } = useWarehouseContext();
  const initialFilter = { warehouse: selectedWarehouse?.id, sort: '-id' };

  const handleFileUpload = async file => {
    if (!currentBulkActionType) {
      toast.error('Please select type first');
      resetFile();
      return;
    }

    try {
      const formData = new FormData();
      formData.append('action_type', currentBulkActionType);
      formData.append('warehouse_id', selectedWarehouse?.id);
      formData.append('file', file);

      await bulkActionApi.bulkFileUpload(formData);
      toast.success('File uploaded successfully');

      tableRef.current?.refetch();
    } catch (error) {
      toast.error('File upload failed. Please try again.');
    } finally {
      resetFile();
    }
  };

  const handleTemplateDownload = () => {
    if (!currentBulkActionType) {
      toast.error('Please select type first');
      return;
    }

    const downloadUrl = bulkActionApi.getTemplateDownloadUrl(
      currentBulkActionType,
    );

    window.open(downloadUrl, '_blank');
    toast.success('Successfully downloaded template.');
  };

  const { fileInputRef, handleFileSelect, handleFileChange, resetFile } =
    useExcelUpload({
      onFileSelect: handleFileUpload,
    });

  const selectBoxActions = currentBulkActionType ? (
    <>
      <div>
        <input
          type="file"
          ref={fileInputRef}
          className="d-none"
          accept=".xlsx,.xls"
          onChange={handleFileChange}
        />
        <Button
          className="h-100"
          variant="falcon-primary"
          size="sm"
          onClick={handleFileSelect}
        >
          Upload
        </Button>
      </div>

      <Button
        variant="falcon-default"
        size="sm"
        onClick={handleTemplateDownload}
      >
        Download Template
      </Button>
    </>
  ) : null;

  return (
    <Table
      ref={tableRef}
      title="File Upload"
      apiService={bulkActionApi}
      sortable={true}
      columns={BULK_ACTION_LIST_COLUMNS}
      selectBoxOptions={BULK_ACTION_SELECT}
      selectBoxActions={selectBoxActions}
      initialFilter={initialFilter}
    />
  );
};

export default BulkAction;
